import { createFetchTypes } from '../../utils/createFetchTypes';

export const GET_ENTITY_CHOICES = createFetchTypes('GET_ENTITY_CHOICES');
